import { faCircleCheck, faListAlt } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { format } from "date-fns/format";
import React from "react";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectHistoryFormEventItem } from "../../queries/object-history/Common";
import { ObjectHistoryCard } from "./ObjectHistoryCard";
import { ObjectHistoryCardContent } from "./ObjectHistoryCardContent";
import { ObjectHistoryCardHeader } from "./ObjectHistoryCardHeader";
import { ObjectHistoryCardSubheader } from "./ObjectHistoryCardSubheader";
import { getEventEndSynopsisText, getEventStartSynopsisText } from "./ObjectHistoryUtils";

export type ObjectHistoryFormEventItemProps = {
    item: IObjectHistoryFormEventItem;
    contextObject?: IeLynxObject;
};

export function ObjectHistoryFormEventItem({ item, contextObject }: ObjectHistoryFormEventItemProps) {
    const theme = useTheme();

    return (
        <ObjectHistoryCard>
            <ObjectHistoryCardHeader
                title={
                    <Stack direction="row">
                        <Box>{format(item.timestamp, "P pp")}</Box>
                    </Stack>
                }
                avatar={
                    item.endTime ?
                        <Box
                            className="fa-layers fa-fw"
                            sx={{
                                position: 'relative',
                                marginRight: theme.spacing(2)
                            }}>
                            <FontAwesomeIcon icon={faListAlt}
                                //color={theme.palette.grey[500]}
                                size={'2x'}
                            />
                            <FontAwesomeIcon icon={faCircleCheck}
                                style={{
                                    bottom: theme.spacing(-3),
                                    right: theme.spacing(-4)
                                }}
                                color={'green'}
                                transform="shrink-1"
                            />
                        </Box> :
                        <FontAwesomeIcon
                            icon={faListAlt}
                            size={'2x'}
                        />
                }
                subheader={
                    <ObjectHistoryCardSubheader
                        item={item}
                        createdBy={item.createdBy}
                        contextObject={contextObject}
                    />
                }
            >
            </ObjectHistoryCardHeader>
            <ObjectHistoryCardContent>
                {item.isStart
                    ? <Typography variant="body2">
                        {getEventStartSynopsisText(item)}
                    </Typography>
                    : <>
                        <Typography variant="body2">{getEventEndSynopsisText(item)}</Typography>
                    </>
                }
            </ObjectHistoryCardContent>
        </ObjectHistoryCard>
    );
}
